import { service } from "../utils/request";

// 商品
export function setRules(data) {
  return service({
    url: "sign/agent.sign_set/edit",
    method: "post",
    data: data
  });
}
export function detailSetRules(data) {
  return service({
    url: "sign/agent.sign_set/detail",
    method: "post",
    data: data
  });
}
//记录
export function signlist(data) {
  return service({
    url: "sign/agent.Sign_Records/index",
    method: "post",
    data: data
  });
}
